export function phoneInputToProponente(phone?: string): {
  telefone: string;
  cod_pais: string;
} {
  if (!phone) return { telefone: "", cod_pais: "+55" };

  const digits = phone.replace(/\D/g, "");
  if (digits.startsWith("55") && digits.length > 11) {
    return {
      telefone: digits.slice(2),
      cod_pais: "+55",
    };
  }

  return { telefone: digits, cod_pais: "+55" };
}

export function proponenteToPhoneInput(
  telefone?: string,
  _cod_pais?: string,
): string | undefined {
  const national = (telefone || "").replace(/\D/g, "");
  if (!national) return undefined;
  return national;
}
